export function notificationCookies() {
    let $cookie = $(".notification");
    let acceptCookie = $cookie.find(".notification-close");
    let $window = $(window);
    let $mainSection;

    if (document.cookie.indexOf("notificationCookiesAccess=") >= 0) {
        $cookie.hide();
    } else {
        $mainSection = $(".main");
        $mainSection.addClass("padding-for-notific");
    }

    acceptCookie.on("click", function (e) {
        e.preventDefault();
        let expiry = new Date();
        expiry.setTime(expiry.getTime() + 1 * 24 * 60 * 60 * 1000);
        document.cookie = "notificationCookiesAccess=yes; path=/; expires=" + expiry.toGMTString();
        $cookie.slideUp();
        $mainSection.removeClass("padding-for-notific");
        $mainSection.css({
            paddingTop: 0,
        });
    });

    if ($mainSection && $mainSection.hasClass("padding-for-notific")) {
        $window.on("load resize", function () {
            $mainSection.css({
                paddingTop: $cookie.outerHeight(),
            });
        });
    }
}



// WEBPACK FOOTER //
// ./assets/js/modules/notificationCookies.js